/**
 * Input formatting hooks for phone numbers and SIRET.
 */

/** Format French phone: 0612345678 → 06 12 34 56 78 */
export function formatPhone(value: string): string {
  const digits = value.replace(/\D/g, '').slice(0, 10)
  return digits.replace(/(\d{2})(?=\d)/g, '$1 ').trim()
}

/** Format SIRET: 12345678900012 → 123 456 789 00012 */
export function formatSiret(value: string): string {
  const digits = value.replace(/\D/g, '').slice(0, 14)
  if (digits.length <= 9) return digits.replace(/(\d{3})(?=\d)/g, '$1 ').trim()
  const siren = digits.slice(0, 9).replace(/(\d{3})(?=\d)/g, '$1 ').trim()
  const nic = digits.slice(9)
  return `${siren} ${nic}`
}

/** Format postal code: 5 digits only */
export function formatPostalCode(value: string): string {
  return value.replace(/\D/g, '').slice(0, 5)
}
